import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: 'admin/user/list',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/user/destroy',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: 'admin/user/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: 'admin/user/createOrUpdate',
      method: 'post',
      data
    })
  },
  ResetPwd(data) {
    return request({
      url: 'admin/user/resetPwd',
      method: 'post',
      data
    })
  },
  ChangePassword(data) {
    return request({
      url: 'admin/user/changePassword',
      method: 'post',
      data
    })
  },
  SaveSimple(data) {
    return request({
      url: 'admin/user/save_simple',
      method: 'post',
      data
    })
  },
  SaveBlackSimple(data) {
    return request({
      url: 'admin/user/save_black_simple',
      method: 'post',
      data
    })
  },
  Detail(data) {
    return request({
      url: 'admin/user/detail',
      method: 'post',
      data
    })
  },
  Member(data) { // 会员列表
    return request({
      url: 'admin/user/member',
      method: 'post',
      data
    })
  },
  MemberPostpone(data) { // 会员延期
    return request({
      url: 'admin/user/memberPostpone',
      method: 'post',
      data
    })
  }
}

export default api
